import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Select from "react-select";

import ActivityLog from '../ActivityLog';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';

function Master_sub_executive() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [executiveData, setExecutiveData] = useState([]);
    const [userRight, setUserRight] = useState([]);

    const [srNo, setSrNo] = useState(0);
    const [employee, setEmployee] = useState("");
    const [designation, setDesignation] = useState({ value: 0, label: "Select" });
    const [address, setAddress] = useState("");
    const [country, setCountry] = useState({ value: 0, label: "Select" });
    const [state, setState] = useState({ value: 0, label: "Select" });
    const [city, setCity] = useState({ value: 0, label: "Select" });
    const [mobile, setMobile] = useState("");
    const [pan, setPan] = useState("");
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState(1);

    const [remark, setRemark] = useState("");

    const [countryData, setCountryData] = useState([]);

    const [cityData, setCityData] = useState([]);

    const [stateData, setStateData] = useState([]);

    const [designationData, setDesignationData] = useState([]);

    const [showAddNewBtn, setShowAddNewBtn] = useState(true);
    const [showFormBtn, setShowFormBtn] = useState(false);

    const [formMode, setFormMode] = useState('Q'); // Q A E 
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [compareData, setCompareData] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'SUB_EXECUTIVE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            Common.callApi(Common.apiSubExecutive, [sid, 'getList'], (result) => {
                let resp = JSON.parse(result);
                setExecutiveData(resp);
            });
            Common.callApi(Common.apiDesignation, [sid, 'getSelect'], (result) => {
                let resp = JSON.parse(result);
                setDesignationData(resp);
            });
            Common.callApi(Common.apiCountry, [sid, 'getCnt'], function (result) {
                setCountryData(JSON.parse(result));
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const addNew = () => {
        setSrNo(0);
        // setActivityLog([]);
        setEmployee("");
        setDesignation({ value: 0, label: "Select" });
        setAddress("");
        setCountry({ value: 0, label: "Select" });
        setState({ value: 0, label: "Select" });
        setCity({ value: 0, label: "Select" });
        setMobile("");
        setPan("");
        setEmail("");
        setStatus(1);
        setFormMode('A');
        setShowAddNewBtn(false);
        setShowFormBtn(true);
    }

    const saveData = () => {
        if (employee === "") {
            setMsgText("Please fill Employee!");
            setMsgBox(true);
        } else if (formMode === 'E' && remark === '') {
            setMsgText('Please fill Remark!');
            setMsgBox(true);
        } else {
            var obj = {
                employee: employee,
                designation: designation.value,
                address: address,
                country: country.value,
                state: state.value,
                city: city.value,
                mobile: mobile,
                pan: pan,
                email: email,
                status: status,
                branch: 0,
                activitytype: srNo * 1 > 0 ? 'MODIFY' : 'CREATE',
                trancategory: 'M',
                trantype: 'MSEXEC',
                trannumber: srNo,
                subtranno: 0,
                remark: remark
            };
            const infoObject = Common.compareArrays(compareData, [obj]);

            if (userRight.edit === "1" && formMode === "E") {
                setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'MSEXEC'));
            }

            Common.callApi(Common.apiSubExecutive, [sid, 'savelist', srNo, JSON.stringify(obj), JSON.stringify(tranAuditTrail)], (result) => {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setShowFormBtn(false);
                    setShowAddNewBtn(true);
                    setRemark("");

                    Common.callApi(Common.apiSubExecutive, [sid, 'getList'], (result) => {
                        let resp = JSON.parse(result);
                        setExecutiveData(resp);
                    });
                    setTranAuditTrail([]);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    const cancelConfirm = () => {
        if (formMode === "A" || formMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setShowFormBtn(false);
        setShowAddNewBtn(true);
        setShowActivityLog(false);
    }

    // const cancelData = () => {
    //     setShowFormBtn(false);
    //     setShowAddNewBtn(true);
    // }
    const fillViewCompareObject = (resp) => {
        const obj2 = {
            employee: resp.employee,
            designation: resp.designation,
            address: resp.address,
            country: resp.country,
            state: resp.state,
            city: resp.city,
            mobile: resp.mobile,
            pan: resp.pan,
            email: resp.email,
            status: resp.status,
            remark: remark
        };
        setCompareData([obj2]);
    }

    const fillEditForm = (id) => {
        setFormMode('Q');
        setShowActivityLog(false);
        Common.callApi(Common.apiSubExecutive, [sid, 'editList', id], (result) => {
            let resp = JSON.parse(result);
            fillViewCompareObject(resp);
            setSrNo(resp.srno);
            setEmployee(resp.employee);
            setDesignation({ value: resp.designation, label: resp.md_desig });
            // setDesignation(resp.designation);
            // mes_designation , md_designation
            setAddress(resp.address);
            setCountry({ value: resp.country, label: resp.cnt_nm });
            setState({ value: resp.state, label: resp.st_nm });
            setCity({ value: resp.city, label: resp.ct_nm });
            setMobile(resp.mobile);
            setPan(resp.pan);
            setEmail(resp.email);
            setStatus(resp.status);

            setShowFormBtn(true);
            setShowAddNewBtn(false);
        });
    }

    const handleSetCountry = (v) => {
        setCountry(v);
        setState({ value: 0, label: "Select" });
        setCity({ value: 0, label: "Select" });
        Common.callApi(Common.apiState, [sid, 'getState', v.value], function (result) {
            setStateData(JSON.parse(result));
        });
    }

    const handleSetState = (v) => {
        setState(v);
        setCity({ value: 0, label: "Select" });
        Common.callApi(Common.apiCity, [sid, 'getCity', v.value], function (result) {
            setCityData(JSON.parse(result));
        });
    }

    const editData = () => {
        setFormMode('E');
    }

    const exportFile = () => {
        var obj = {
            right: 'SUB_EXECUTIVE'
        }
        Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(obj)]);
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "MSEXEC", trannumber: srNo, trancategory: "M" });
    }

    return (
        <>
            <LoginHeader />
            <Menu />

            <Container fluid>
                <Row>
                    <Col>
                        <h1>Sub Executive </h1>
                    </Col>
                </Row>
                {
                    showAddNewBtn ?
                        <Row>
                            <Col>
                                {userRight.add === "1" ?
                                    <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={addNew}>
                                        Add New
                                    </Button>
                                    : null}
                                {
                                    userRight.query === "1" ?
                                        <>&nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={exportFile}>Export</Button>
                                        </>
                                        : null
                                }
                            </Col>
                        </Row>
                        : null

                }
                <Row><Col>&nbsp;</Col></Row>
                {
                    showFormBtn ?
                        <>
                            <Row>
                                <Col className="divContentCenter">
                                    <div className="maxFormWidth">
                                        <Form>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Serial Number</Form.Label>
                                                        <Form.Control type="text" placeholder="Serial Number" value={srNo}
                                                            disabled />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Employee<span className="mandatory text-danger">*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Employee" maxLength={100}
                                                            value={employee}
                                                            onChange={(e) => Common.validateAlpValue(e.target.value, setEmployee)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Designation</Form.Label>
                                                        <Select options={designationData} value={designation} onChange={v => setDesignation(v)}
                                                            isDisabled={formMode === 'Q'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Address</Form.Label>
                                                        <Form.Control type="text" placeholder="Address" maxLength={100}
                                                            value={address}
                                                            onChange={(e) => setAddress(e.target.value)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Country</Form.Label>
                                                        <Select options={countryData} value={country} onChange={v => handleSetCountry(v)}
                                                            isDisabled={formMode === 'Q'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>State</Form.Label>
                                                        <Select options={stateData} value={state} onChange={v => handleSetState(v)}
                                                            isDisabled={formMode === 'Q'} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>City</Form.Label>
                                                        <Select options={cityData} value={city} onChange={v => setCity(v)}
                                                            isDisabled={formMode === 'Q'} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Mobile</Form.Label>
                                                        <Form.Control type="text" placeholder="Mobile" maxLength={10}
                                                            value={mobile}
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setMobile)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'}
                                                        />

                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>PAN</Form.Label>
                                                        <Form.Control type="text" placeholder="PAN" maxLength={100}
                                                            value={pan}
                                                            onChange={(e) => setPan(e.target.value)}
                                                            onBlur={(e) => Common.validatePan(e.target.value, setPan)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Email</Form.Label>
                                                        <Form.Control type="text" placeholder="Email" maxLength={100}
                                                            value={email} onChange={(e) => setEmail(e.target.value)}
                                                            onBlur={(e) => Common.validtateEmail(e.target.value, setEmail)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Status</Form.Label>
                                                        <Form.Select value={status} onChange={e => setStatus(e.target.value)} disabled={formMode === 'Q'} required>
                                                            <option value="1">ACTIVE</option>
                                                            <option value="0">INACTIVE</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>&nbsp;</Col>
                                            </Row>
                                            {
                                                formMode === 'E' ?
                                                    <>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group>
                                                                    <Form.Label>Remark<span className="mandatory text-danger">*</span></Form.Label>
                                                                    <Form.Control type="text" placeholder="Remark" maxLength={50}
                                                                        value={remark}
                                                                        onChange={(e) => Common.validateAlpValue(e.target.value, setRemark)}
                                                                        autoComplete="off"
                                                                        required />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col>&nbsp;</Col>
                                                            <Col>&nbsp;</Col>
                                                            <Col>&nbsp;</Col>
                                                        </Row>
                                                    </> :
                                                    null
                                            }
                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    {/* <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                        saveData()}>Save</Button>&nbsp;
                                                    <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() =>
                                                        cancelData()}>Cancel</Button> */}

                                                    <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() =>
                                                        cancelConfirm()}>Back</Button>&nbsp;&nbsp;

                                                    {
                                                        (userRight.edit === "1" && formMode === 'Q') ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                editData()}>Edit</Button>&nbsp;
                                                        </> : null
                                                    }
                                                    {
                                                        (userRight.edit === "1" && formMode === 'E') || (userRight.add === "1" && formMode === 'A') ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                saveData()}>Save</Button>&nbsp;
                                                        </> : null
                                                    }
                                                    {
                                                        (userRight.query === "1" && (formMode === 'E' || formMode === 'Q')) ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                btnActivityLog()}>Activity Log</Button>&nbsp;
                                                        </> : null
                                                    }
                                                </Col>
                                            </Row>
                                            <Row><Col>&nbsp;</Col></Row>
                                        </Form>
                                    </div>
                                </Col>
                            </Row>
                            {/* <Row>
                                {
                                    showActivityLog &&
                                    <>
                                        <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
                                    </>
                                }
                            </Row> */}
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                {userRight.edit === "1" ? <th></th> : null}
                                                <th className="textRight">Sr No</th>
                                                <th>Employee</th>
                                                <th>Designation</th>
                                                <th>Address</th>
                                                <th>Country</th>
                                                <th>State</th>
                                                <th>City</th>
                                                <th>Mobile</th>
                                                <th>PAN</th>
                                                <th>Email</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {executiveData.map((res) =>
                                                <tr key={res.mes_srno}>
                                                    {userRight.edit === "1" ?
                                                        <td className="textCenter" >
                                                            <span className="handCursor" onClick={() => fillEditForm(res.mes_srno)} >
                                                                <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                            </span>
                                                        </td>
                                                        : null
                                                    }
                                                    <td className="textRight">{res.mes_srno}</td>
                                                    <td>{res.mes_employee}</td>
                                                    <td>{res.md_designation}</td>
                                                    <td>{res.mes_address}</td>
                                                    <td>{res.cnt_name}</td>
                                                    <td>{res.state_name}</td>
                                                    <td>{res.city_name}</td>
                                                    <td>{res.mes_mobile}</td>
                                                    <td>{res.mes_pan}</td>
                                                    <td>{res.mes_email}</td>
                                                    <td>{res.mes_status == 1 ? "ACTIVE" : "INACTIVE"}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                }
            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            {/* <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div> */}
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
            </div>
        </>
    )
}

export default Master_sub_executive;
